<script lang="ts" context="module">
  import type {SvelteComponent} from 'svelte';
  import {getTargetPositionBasedOnNode} from './popup-helpers';
  import {writable} from 'svelte/store';
  import {horizontalSlide} from '../../../transitions/transitions';
  import {alertToScreenReader} from 'svelte-dnd-action';
  export let popupboxfont = writable('none');
  let skipNextClickHideEvent = false;
  let holdSkipNextEvent = false;
  let box: any;
  let shown = false;
  let component = writable<typeof SvelteComponent | null>(null);
  let args = writable<any>(null);

  let onExit: (() => any) | null = () => {
    popupboxfont.set('none');
  };

  export function doNotHidePopupOnNextClick(hold = false) {
    skipNextClickHideEvent = true;
    holdSkipNextEvent = hold;
  }
  export function hidePopupOnNextClick() {
    holdSkipNextEvent = false;
    skipNextClickHideEvent = false;
  }
  export function attachPopup(node: HTMLElement | null, insertComponent: typeof SvelteComponent, argsInput?: any) {
    shown = false;
    component.set(insertComponent);
    args.set(argsInput);
    // const pos = getTargetPositionBasedOnNode(node);
    // box.style.position = 'absolute';
    // box.style.left = `${pos.left}px`;
    // box.style.top = `${pos.top}px`;
    setTimeout(() => {
      shown = true;
    }, 250);
  }

  export function closePopup() {
    component.set(null);
    shown = false;
    if (onExit) onExit();
  }
</script>

<script lang="ts">
  $: cssClass = $component == null ? 'hidden' : 'block';

  function hide(ev: MouseEvent) {
    if (skipNextClickHideEvent) {
      console.log('Should skip event');
      if (!holdSkipNextEvent) skipNextClickHideEvent = false;
      return;
    }
    setTimeout(() => {
      if (!shown) return;
      const target = ev.target;
      if (target && box.contains(target as HTMLElement)) return;
      component.set(null);
      shown = false;
      if (onExit) onExit();
    }, 10);
  }

  function close() {
    component.set(null);
    shown = false;
    if (onExit) onExit();
  }
</script>

<svelte:window on:click={hide} />
<div
  class={'rounded-tr-log absolute z-40 overflow-auto rounded-br-lg border-r border-gray-200 bg-gray-100 p-4 shadow-sm ' +
    cssClass}
  id="popup_box"
  bind:this={box}
>
  <div class="relative flex h-full flex-col gap-2">
    <div class="absolute right-0 top-0 flex w-full">
      {#if $args && $args.title}
        <span class=" block text-sm font-bold text-slate-600">{$args.title}</span>
      {/if}
      <i class="fa fa-times ml-auto block cursor-pointer text-gray-600" on:click={close} on:keypress={close} />
    </div>
    <div class="mt-7 flex-grow">
      <svelte:component this={$component} {...$args} />
    </div>
  </div>
</div>

<style lang="postcss">
  #popup_box {
    width: 370px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
</style>
